export default function HeroSection() {
  return (
    <section className="relative min-h-[620px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1B4D3E] via-[#1a5c3a] to-[#C8A951]"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-transparent"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-green-200/80 mb-4">
            REGISTERED U.S. DEPARTMENT OF STATE COURIER
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Fast Passport Renewal — As Little as 3 Business Days
          </h1>

          <p className="text-base md:text-lg text-green-100/90 max-w-3xl mx-auto mb-10 leading-relaxed">
            No office visit. No passport agency trip. No weeks of waiting. Fast Passport Center is a registered State Dept courier with daily reserved agency access — renewing your passport faster than any post office or retail counter, at a fraction of the cost.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
            <a
              href="https://fastpassportcenter.com/checkout/?passport=passport-renewal"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-[#C8A951] hover:bg-[#b8942e] text-[#1B4D3E] font-bold text-base md:text-lg rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-passport-line text-xl"></i>
              Renew My Passport Fast
            </a>
            <a
              href="tel:8772530084"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 border-2 border-white/40 hover:border-white hover:bg-white/10 text-white font-semibold text-base md:text-lg rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
              Call 877-253-0084
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-white/75 text-xs md:text-sm">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-government-fill"></i> Registered State Dept. Courier
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-home-office-line"></i> No Office Visit Required
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-shield-check-line"></i> A+ BBB Accredited
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-history-line"></i> 20+ Years Experience
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-money-dollar-circle-line"></i> From $195
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}